import { Phone } from "lucide-react";
import { NAP } from "../lib/data";

// Floating sticky Call-Now button on mobile only.
// Hidden on lg+ screens (desktop has the nav CTA already visible).
export default function MobileCallButton() {
  return (
    <a
      href={NAP.phoneTel}
      data-testid="mobile-sticky-call-btn"
      className="lg:hidden fixed bottom-4 left-4 right-4 z-[60] af-btn-primary justify-center shadow-[0_15px_35px_-5px_rgba(220,38,38,0.5)] animate-[af-rise_0.5s_ease_forwards]"
      aria-label={`Call ${NAP.phoneDisplay}`}
    >
      <Phone size={18} />
      <span className="tracking-wider">CALL NOW · {NAP.phoneDisplay}</span>
    </a>
  );
}
